import React, { useEffect } from "react";
import { Text, View } from "react-native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";

const PasswordInfoTooltip = ({
  styles,
  password,
  setShowPasswordTooltip,
  showPasswordTooltip,
}) => {
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const isAtLeast8Characters = password.length >= 8;

  useEffect(() => {
    if (
      hasNumber &&
      hasSpecialCharacter &&
      hasUppercase &&
      hasLowercase &&
      isAtLeast8Characters &&
      showPasswordTooltip
    ) {
      setShowPasswordTooltip(false);
    }
  }, [
    hasNumber,
    hasSpecialCharacter,
    hasUppercase,
    hasLowercase,
    isAtLeast8Characters,
    showPasswordTooltip,
  ]);

  if (!showPasswordTooltip) return null;

  return (
    <View style={styles.tooltip}>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          {
            color: hasNumber ? AppColors.appGreenColor_51AF07 : "red",
            lineHeight: 20,
          },
        ]}
      >
        {hasNumber ? "✔" : "✘"} Contains at least 1 number
      </Text>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          {
            color: hasSpecialCharacter ? AppColors.appGreenColor_51AF07 : "red",
            lineHeight: 20,
          },
        ]}
      >
        {hasSpecialCharacter ? "✔" : "✘"} Contains at least 1 special character
      </Text>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          {
            color: hasUppercase ? AppColors.appGreenColor_51AF07 : "red",
            lineHeight: 20,
          },
        ]}
      >
        {hasUppercase ? "✔" : "✘"} Contains at least 1 uppercase letter
      </Text>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          {
            color: hasLowercase ? AppColors.appGreenColor_51AF07 : "red",
            lineHeight: 20,
          },
        ]}
      >
        {hasLowercase ? "✔" : "✘"} Contains at least 1 lowercase letter
      </Text>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          {
            color: isAtLeast8Characters
              ? AppColors.appGreenColor_51AF07
              : "red",
            lineHeight: 20,
          },
        ]}
      >
        {isAtLeast8Characters ? "✔" : "✘"} Minimum length of 8 characters
      </Text>
    </View>
  );
};

export default PasswordInfoTooltip;
